export const normalizeStoreRecord = (store) => ({
  id: String(store?.id ?? store?._id ?? ''),
  name: store?.name ?? store?.store ?? '',
  location: store?.location || '',
  group_id: store?.group_id || ''
});

export const dedupeStoresById = (stores = []) => {
  const seen = new Set();

  return stores.reduce((acc, store) => {
    const normalizedStore = normalizeStoreRecord(store);

    if (!normalizedStore.id || seen.has(normalizedStore.id)) {
      return acc;
    }

    seen.add(normalizedStore.id);
    acc.push(normalizedStore);
    return acc;
  }, []);
};

export const normalizeStoreSearchText = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const filterStoreOptions = (options, { inputValue }) => {
  const normalizedQuery = normalizeStoreSearchText(inputValue);

  if (!normalizedQuery) {
    return options;
  }

  return options.filter((option) => {
    const searchableText = normalizeStoreSearchText(`${option?.name || ''} ${option?.location || ''}`);
    return searchableText.includes(normalizedQuery);
  });
};
